export const brandColors = {
  50:  '#f4f7fa',
  100: '#e7edf4',
  200: '#c9d6e3',
  300: '#a4b8cc',
  400: '#7a94ae',
  500: '#5a7087',
  600: '#485c70',
  700: '#364759',
  800: '#263340',
  900: '#1a242e',
};

export const neutralColors = {
  50:  '#fbfaf9',
  100: '#f4f2f0',
  200: '#e8e5e3',
  300: '#d5d0cd',
  400: '#aaa4a1',
  500: '#857e7a',
  600: '#65605d',
  700: '#4a4645',
  800: '#302d2c',
  900: '#1b1918',
};

export const pillarColors = {
  'higher-purpose': {
    label: 'Higher Purpose',
    description: 'Foundational, grounding. Why we exist.',
    base: '#e29612',
    bg:   '#fdf7ec',
    text: '#8e5e0b',
    cssVar: '--pillar-higher-purpose',
    bgCssVar: '--pillar-higher-purpose-bg',
    textCssVar: '--pillar-higher-purpose-text',
  },
  'purpose-strategy': {
    label: 'Purpose-driven Strategy',
    description: 'Strategic clarity. Where we are going.',
    base: '#298e8b',
    bg:   '#e7f8f8',
    text: '#195755',
    cssVar: '--pillar-purpose-strategy',
    bgCssVar: '--pillar-purpose-strategy-bg',
    textCssVar: '--pillar-purpose-strategy-text',
  },
  'conscious-communication': {
    label: 'Conscious Communication',
    description: 'Clarity and openness. How we speak.',
    base: '#218cca',
    bg:   '#e9f5fb',
    text: '#14557b',
    cssVar: '--pillar-conscious-communication',
    bgCssVar: '--pillar-conscious-communication-bg',
    textCssVar: '--pillar-conscious-communication-text',
  },
  'engaged-people': {
    label: 'Intrinsically Engaged People',
    description: 'Human, growing. Who we are.',
    base: '#3b9163',
    bg:   '#edf8f2',
    text: '#23573b',
    cssVar: '--pillar-engaged-people',
    bgCssVar: '--pillar-engaged-people-bg',
    textCssVar: '--pillar-engaged-people-text',
  },
  'connected-customers': {
    label: 'Empathetically Connected Customers',
    description: 'Warmth and empathy. Who we serve.',
    base: '#dd562c',
    bg:   '#fcf1ed',
    text: '#8c3217',
    cssVar: '--pillar-connected-customers',
    bgCssVar: '--pillar-connected-customers-bg',
    textCssVar: '--pillar-connected-customers-text',
  },
  'agility': {
    label: 'Agility and Responsiveness',
    description: 'Movement, adaptability. How we evolve.',
    base: '#4067b5',
    bg:   '#f0f3fa',
    text: '#253c6a',
    cssVar: '--pillar-agility',
    bgCssVar: '--pillar-agility-bg',
    textCssVar: '--pillar-agility-text',
  },
};

export const statusColors = {
  success: {
    base: '#319b58',
    bg:   '#edfcf3',
    text: '#1d5d35',
  },
  warning: {
    base: '#d89013',
    bg:   '#fff9f0',
    text: '#8d5e0c',
  },
  error: {
    base: '#d02525',
    bg:   '#fef1f1',
    text: '#8b1818',
  },
};

export const colors = {
  light: {
    brand: brandColors,
    neutral: neutralColors,
    success: statusColors.success,
    warning: statusColors.warning,
    error: statusColors.error,
  },
  dark: {
    brand: {
      50:  '#121a21',
      100: '#1a242d',
      200: '#27333f',
      300: '#3c4c5d',
      400: '#566b81',
      500: '#748faa',
      600: '#97adc4',
      700: '#b5c7d9',
      800: '#d5e0eb',
      900: '#edf2f7',
    },
    neutral: {
      50:  '#1b1918',
      100: '#252322',
      200: '#353231',
      300: '#504b49',
      400: '#817874',
      500: '#a39c99',
      600: '#c4beba',
      700: '#ddd8d5',
      800: '#edebe8',
      900: '#f9f7f6',
    },
    success: {
      base: '#45c474',
      bg:   '#0c2716',
      text: '#a1edbd',
    },
    warning: {
      base: '#eca427',
      bg:   '#422c06',
      text: '#ffdda3',
    },
    error: {
      base: '#dd4040',
      bg:   '#3d0b0b',
      text: '#f8b5b5',
    },
  },
};

export type PillarKey = keyof typeof pillarColors;
export type ColorShade = keyof typeof brandColors;
